module.exports = __webpack_public_path__ + "img/meemo_air.b1036376.png";